import { useEffect } from "react";
import { GateConfirmModalHeader } from "./GateConfirmModalHeader";
import { GateConfirmModalFormWrapper } from "./GateConfirmModalFormWrapper";

const GateConfirmModal = ({
  device = {},
  setDevice,
  setOpenGateConfirmModal,
  getGateLists,
  listing,
  getListing = () => {},
}) => {
  useEffect(() => {
    if (!listing?.gate_allowed) {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    }
  }
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-650px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <GateConfirmModalHeader
              listing={listing}
               device={device}
               setDevice={setDevice}
               setOpenGateConfirmModal={setOpenGateConfirmModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <GateConfirmModalFormWrapper
                 device={device}
                 setDevice={setDevice}
                 setOpenGateConfirmModal={setOpenGateConfirmModal}
                 getGateLists={getGateLists}
                 listing={listing}
                 getListing={getListing}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { GateConfirmModal };
